import { PerspectiveCamera, OrthographicCamera } from "@react-three/drei";

import { CAMERA } from "@graphic/constants";
import { useStartPosition } from "@graphic/hooks";
import { CameraType } from "@graphic/types";

export const CameraSetup = ({ type }: { type: CameraType }) => {
  const startPosition = useStartPosition();

  const { x, y, z } = startPosition;

  return type === "PERSPECTIVE" ? (
    <PerspectiveCamera
      makeDefault
      fov={1}
      position={[x, y, z]}
      near={CAMERA.PERSPECTIVE.NEAR}
      far={CAMERA.PERSPECTIVE.FAR}
      up={[0, 0, 1]}
      zoom={CAMERA.PERSPECTIVE.ZOOM_DEFAULT}
      frames={60}
    />
  ) : (
    <OrthographicCamera
      makeDefault
      position={[x, y, z]}
      near={CAMERA.ORTHOGRAPIC.NEAR}
      far={CAMERA.ORTHOGRAPIC.FAR}
      up={[0, 0, 1]}
      zoom={CAMERA.ORTHOGRAPIC.ZOOM_DEFAULT}
      frames={60}
    />
  );
};

export default CameraSetup;
